/* The AIFM's own part comes back under the period's id, so it is told apart from the funds. */
export function readParseSummary(parse, periodId) {
  if (!Array.isArray(parse) || !parse.length) return null;
  const isManager = row => (periodId && row.fund_id === periodId) || row.fund_name === 'AIFM';
  const aifs = parse.filter(row => !isManager(row));
  return {
    aifs,
    converted: aifs.filter(row => row.status === 'ok'),
    missed: aifs.filter(row => row.status !== 'ok'),
    missedManager: parse.find(row => isManager(row) && row.status !== 'ok') || null
  };
}
